/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { UserCommandError } from '@/models/user.command.error';

/**
 *
 * @class UserCommandMergeResult
 *
 * @brief the model for the result we get back from merging a scenario
 * with user commands.
 *
 * {
 *   "results": {
 *     "status": "ERRORS",
 *     "validation_time": 0.006,
 *     "blob": "\/tmp\/level_1_test_2-merged.json",
 *     "merge_time": 0.078,
 *     "total_time": 0.084
 *   },
 *   "errors": [ <UserCommandError>, ... ]
 * }
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      November 2023
 *
 */
export class UserCommandMergeResult {

  /** overall status */
  public status: string             = '';

  /** blob key pointing to the merged scenario (now has user commands embedded) */
  public blob: string               = '';

  /** seconds to validate */
  public validation_time: number    = 0.0;

  /** seconds to do the merge */
  public merge_time: number         = 0.0;

  /** total time in seconds */
  public total_time: number         = 0.0;

  /** the validation errors (if any) */
  public errors: UserCommandError[] = [];

  /** the unique ID we can use for long-running progress updates */
  public updateId: string           = ''

  /** standard constructor, allow for partial data to be given */
  public constructor(init?: Partial<UserCommandMergeResult>) {

    /* if we hav an errors list...up convert to command error objects */

    if (typeof(init.errors) != 'undefined') {

      init.errors = init.errors.map((x: any): UserCommandError => {

        if (x instanceof UserCommandError) {

          /* no conversion required */

          return x;
        }

        /* convert from raw JSON structure to a proper object */

        return new UserCommandError(x);

      });

    }

    Object.assign(this, init);
  }

  public to_json(): any {

    return {
      status:          this.status,
      blob:            this.blob,
      validation_time: this.validation_time,
      merge_time:      this.merge_time,
      total_time:      this.total_time,
      errors:          this.errors.map((x: UserCommandError): any => x.to_json()),
      updateId:        this.updateId
    };
  }
}
